module.exports = __webpack_public_path__ + "static/img/1-1.bab9ae3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/1/1-1.png
// module id = /rW2
// module chunks = 0